export default __webpack_public_path__ + "static/media/SecuredPayment.66a9f80a.svg";